function handleServiceCTA(service) {

  // We only need to run the click handler on pages with
  // an Email query parameter
  const email = getQueryVariable('Email');
  if ( !email ) {
    return;
  }

  // We have an email
  const data = {
    email: email,
    service: "Service: " + service,
  };
  fetch('/contact-form-processing/update-lead.php', {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
}